module.exports = __webpack_public_path__ + "img/pre_registration.99f4bb9.png";